import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, inject, ref } from 'vue';
import Papa from 'papaparse';
import { set } from 'lodash';
import DropFile from '@/components/base/DropFile.vue';
import eventBus from '@/foundations/services/eventBus';

type ListState = {
  resource: string;
};

type Props = {
  onSave?: (entries: object[]) => Promise<void>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportButton',
  props: {
    onSave: null
  },
  setup(__props: any) {

const props = __props as {
  onSave?: (entries: object[]) => Promise<void>;
}



const listState = inject<ListState | undefined>('listState', undefined);
const dialog = ref(false);

const headers = ref<any[]>([]);
const rows = ref<any[]>([]);
const file = ref<File>();
const store = ref<any>();

const useStore = () => {
  const vm = getCurrentInstance()!.proxy;
  store.value = vm.$store;
};
useStore();

const arrayToJson = (rowHeaders: string[], values: any[]): any => {
  const val = {};
  if (values.length === rowHeaders.length) {
    for (let i = 0; i < rowHeaders.length; i += 1) {
      set(val, rowHeaders[i].trim(), values[i]);
    }
    return val;
  }
  return undefined;
};

const uploadActive = computed<boolean>(() => rows.value.length > 0);

const handleFileChange = (files: File[]) => {
  // eslint-disable-next-line prefer-destructuring
  file.value = files[0];
  if (files && files.length > 0) {
    Papa.parse(files[0], {
      complete: (results: any) => {
        headers.value = [];
        rows.value = [];
        if (results.data.length > 0) {
          results.data[0].forEach((name: string) => {
            headers.value.push({ text: name.trim(), align: 'end', value: name.trim() });
          });
        }
        if (results.data.length > 1) {
          results.data
            .slice(1)
            .map((arrayRow: any[]) => arrayToJson(results.data[0], arrayRow))
            .forEach((row: any) => {
              rows.value.push(row);
            });
        }
      },
    });
  } else {
    headers.value = [];
    rows.value = [];
  }
};

const uploadFile = async (objects: any[]) => {
  console.log(`Uploading ${objects.length} rows`);

  eventBus.$emit('snackbar.open', `Import of ${objects.length} rows started.`);

  if (props.onSave) {
    await props.onSave(objects);
  } else {
    objects.forEach((obj) => {
      store.value.dispatch(`${listState!.resource}/create`, { data: obj });
    });
  }

  dialog.value = false;
};

const triggerUploadFile = () => {
  if (file.value) {
    Papa.parse(file.value, {
      complete: (results: any, filePapa: File) => {
        const dataRows = results.data
          .slice(1)
          .map((arrayRow: any[]) => arrayToJson(results.data[0], arrayRow))
          .filter((row: any) => !!row);

        if (dataRows.length) {
          uploadFile(dataRows);
        }
      },
    });
  }
};

return { __sfc: true,props, listState, dialog, headers, rows, file, store, useStore, arrayToJson, uploadActive, handleFileChange, uploadFile, triggerUploadFile, DropFile }
}

})